/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetMetricDataSourceByKeyPathParams = NonNullable<
  operations['getMetricDataSourceByKey']['parameters']['path']
>;

export type GetMetricDataSourceByKeyQueryParams = NonNullable<
  operations['getMetricDataSourceByKey']['parameters']['query']
>;

export interface Input extends GetMetricDataSourceByKeyPathParams {
  apiVersion?: string;
  query?: GetMetricDataSourceByKeyQueryParams;
}

export async function getMetricDataSourceByKey(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/projects/{projKey}/metric-data-sources/{dataSourceKey}', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
